import React from "react";

const PaymentPage = () => {
  const handlePayment = () => {
    // Örnek olarak herkesin bildiği Stripe ödeme sayfasına yönlendirme
    window.location.href = "https://buy.stripe.com/test_1234567890";
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Ödeme Sayfası</h2>
        <p>Lütfen seçtiğiniz plan için ödemeyi tamamlayın.</p>
        <button style={styles.button} onClick={handlePayment}>
          Ödemeye Git
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff8e1",
  },
  card: {
    backgroundColor: "#fffaf0",
    padding: "40px 50px",
    borderRadius: "15px",
    boxShadow: "0 6px 25px rgba(0, 0, 0, 0.15)",
    textAlign: "center",
  },
  button: {
    backgroundColor: "#b8860b",
    color: "white",
    border: "none",
    padding: "12px 25px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "20px",
  },
};

export default PaymentPage;
